<sc-flex fitHeight vertical stretchContent>
  <sc-flex-fitting-content vertical>
      <app-transport-list [componentIdentifier]="widgetIdentifier+'-transport-table'" [transports]="data"
        [columnsToDisplay]="columnsToDisplay" [selectedTransportId]="selectedTransportId"
        [sortDefinition]="currentFilterSortDefinition"
        (transportSelected)="onTransportSelected($event)"></app-transport-list>
  </sc-flex-fitting-content>
  <sc-content-spacer vertical></sc-content-spacer>
  <app-transport-counts
    [counts]="transportCounts"></app-transport-counts>
</sc-flex>
